import React from "react";
import { multimediaEpaycoUrl } from "../../utils/multimedia";
import {Flex,colors} from "../ui";
import styled from "@emotion/styled";
/** @jsx jsx */
import {jsx, css, keyframes} from '@emotion/core';

const ContCodigo = styled.div`

    text-align:center;
    background-image:url(${multimediaEpaycoUrl('/dashboard/recaudo/proyecto/imagenes/diagonal.png')});
    background-repeat:no-repeat;
    background-size:25% auto;
    background-position:45% 10%;
    position:relative;
    width:100%;
    max-width:300px;
    margin:auto;

    img{
        position:absolute;
        width:35%;
        bottom:0;
        right:0;
    }


    @media all and (max-width:768px){

    background-size:15% auto;
    background-position:45% 10%;
    position:relative;

      img{
        position:absolute;
        width:15%;
        bottom:0;
        right:25%;
    }
    }

`

const BtnOrange = styled.button`

    background:${colors.naranja};
    color:white;
    height:50px;
    padding:0 1em;
    width:100%;
    max-width:250px;
    border-radius:4px;
    border:none;

`
const Codigo = css`
    font-weight:700;
    font-size:5em;

    @media all and (min-width:768px){
           font-size:9em;
    }
`
const ContMessage = styled.div`
    h1 {
        color:${colors.naranja};
    }
`

const Error = ({codigo,mensaje,titulo}) => {

    return(
        <Flex className={"container  px-0"}>
            <div className="col-12 col-md-6">
                <ContCodigo>
                    <h1 css={Codigo}>{codigo}</h1>
                    <a href="https://epayco.co/"><img src={multimediaEpaycoUrl("/dashboard/recaudo/proyecto/imagenes/diagonal.png")} alt=""/></a>
                </ContCodigo>
            </div>
            <ContMessage className="col-12 col-md-6 text-center text-md-left px-0">
                <h1>{titulo}</h1>
                <p>{mensaje}</p>
                <BtnOrange> <a href="https://epayco.co/" className={"cb"}>Ir a ePayco</a></BtnOrange>
            </ContMessage>
        </Flex>
    )
}

export default Error;